import actions from "./actions";
import mutations from "./mutations";
import { pagination } from "@/store/helpers";

export default {
  namespaced: true,
  state: {
    ...pagination,
    logs: {
      ...pagination,
    },
    query: "",
    queryLogs: "",
  },
  actions,
  getters: {
    getQuery(state) {
      return state.query;
    },
    getQueryLogs(state) {
      return state.queryLogs;
    },
  },
  mutations,
};
